import { render } from "./EditWebhookChannel.vue?vue&type=template&id=5b83342e"
import script from "./EditWebhookChannel.vue?vue&type=script&lang=js"
export * from "./EditWebhookChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__